import { useEffect, useState } from 'react'
import { QueryStatus, QueryStatusType } from 'src/types'
import { HttpWRM, OperacionWRM } from '../api'

type UseOperacionResult<TOperacion> = {
    status: QueryStatusType
    operacion: TOperacion | undefined
}

export const useOperacionWRM: (idOperacion: number) => UseOperacionResult<OperacionWRM> = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionWRM>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpWRM.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return { status, operacion }
}
